export default {
  SESSION_PUBLIC: 'sessionPublic',
  SESSION_EDIT: 'sessionEdit',
  SESSION_DIRECT: 'sessionDirect',
  CAMPAIGN_PUBLIC: 'campaignPublic',
  CAMPAIGN_EDIT: 'campaignEdit',
  CAMPAIGN_DIRECT: 'campaignDirect',
  CANCELED: 'canceled',
};
